import { PayCalendar } from '../../types';
import { WebappApiResponse } from '@webapp-next/lib/types/request/request';
import { get } from '@webapp-next/lib/request/webapp/apiv2';

export async function getListPayCalendar(): Promise<PayCalendar[]> {
  const {
    data,
  }: {
    data: WebappApiResponse<PayCalendar[]>;
  } = await get('/api/management/v2/pay-calendars?filters[]=status:=1');

  return data.data;
}

export async function getListPayCalendarByBusinessNumber(
  businessNumber: string
): Promise<PayCalendar[]> {
  const {
    data,
  }: {
    data: WebappApiResponse<PayCalendar[]>;
  } = await get(
    `/api/management/v2/pay-calendars?filters[]=status:=1&filters[]=businessNumber:=${businessNumber}`
  );

  return data.data;
}
